
import dialog_tarjeta from "../../dialog/dialog_tarjeta/dialog_tarjeta.vue"
import * as XLSX from 'xlsx'
export default {

  props: ['loading', 'filas', 'columnas', 'nombre_tabla',
    'show_expand', 'tarjeta',
    'mensual', 'anual'],

  components: { dialog_tarjeta },

  data() {
    return {
      expanded: [],
      singleExpand: false,
      search: "",
      tipo: true, //compras y ventas true cierra anual false
      lodingData: false,
      mostrarDialogTarjeta: false,
      dialogMensualAnual: false,
      dialogAnual: false,
      data_fecha: {
        fecha_usuario: "",
        fecha: ""
      },
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,
      item: "",
      facturas: [],
      totalFacturas: "",
      declaraciones: [],
      totales_facturas: 0,
      totales_retenciones: 0,
      totales_impuesto: 0,
      select: "",
      items: [],
      anio_auxiliar: '',
      loading_pdf: false,
      item_aux: '',
      copyText: '',
      isSelect: false,
    }
  },
  created() {
    console.log("tabla_isr.component");
    let anio_auxiliar = new Date().getFullYear();
    for (let i = 0; i < 10; i++) {
      this.items.push(anio_auxiliar + i);
      this.items.unshift(anio_auxiliar - i);
    }
  },
  computed: {
    size() {
      console.log('size');
      const size = { xs: "x-small", sm: 'small', md: 'medium', lg: 'large', xl: 'x-large' }[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {}
    }
  },
  watch: {
    tipo() {
      console.log("tipo");
      if (this.tipo) {
        this.data_fecha.fecha = '';
        this.data_fecha.fecha_usuario = '';
        this.totalFacturas = '';
        this.facturas = '';
        this.date = '';
      } else {
        this.data_fecha.fecha = '';
        this.data_fecha.fecha_usuario = '';
        this.totalFacturas = '';
        this.facturas = '';
        this.date = '';
      }
    },
  },
  methods: {
    async exportarPdfAnual() {
      console.log("exportarPdfAnual");
      try {
        this.loading_pdf = true;
        let r = await this.$store.state.services.reportesService.obtenerCierreAnualROS(this.anio_auxiliar, this.item.id);
        console.log(r);
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = r.data.data
        link.setAttribute('download', `${this.item.cui}_${this.item.nombre}_CIERRE_ANUAL.pdf`)
        document.body.appendChild(link)
        link.click()
        this.loading_pdf = false;
      } catch (error) {
        console.log(error);
        this.loading_pdf = false;
        this.$toast.error("No es posible procesar la información");
      }
    },
    async copyCode(tipo, item) {
      console.log("copyCode");
      switch (tipo) {
        case 1:
          await navigator.clipboard.writeText(this.totalFacturas.replace(",", ""));
          this.copyText = "Copiado"
          break;
        case 2:
          await navigator.clipboard.writeText(this.retenciones.replace(",", ""));
          this.copyText = "Copiado"
          break;
        case 3:
          await navigator.clipboard.writeText(item);
          this.copyText = "Copiado"
          break;
        default:
          break;
      }
    },
    reset() {
      console.log("reset");
      this.copyText = this.text
    },
    async exportarPdf() {
      console.log("exportarPdf");
      console.log(this.data_fecha.fecha_usuario);
      console.log(this.item);
      try {
        this.loading_pdf = true;
        let r = await this.$store.state.services.reportesService.obtenerPdfComprasVentas(this.item.id, this.data_fecha.fecha_usuario.split("/")[0], this.data_fecha.fecha_usuario.split("/")[1]);
        console.log(r);
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = r.data.data
        link.setAttribute('download', `${this.item.cui}_${this.item.nombre}_LTE.pdf`)
        document.body.appendChild(link)
        link.click()
        this.loading_pdf = false;
      } catch (error) {
        console.log(error);
        this.loading_pdf = false;
        this.$toast.error("No es posible procesar la información");
      }
    },
    convertirnumero(numero) {
      //si no es un numero valido es cero
      if (!numero) {
        return 0;
      }

      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      return dollarUSLocale.format(Math.abs(numero))
    },
    exportarExcel(tipo) {
      console.log("exportarExcel");
      let data = XLSX.utils.json_to_sheet(this.facturas)
      const workbook = XLSX.utils.book_new()
      let filename = ''
      if (tipo == 1) {
        filename = 'facturas_emitidas' + this.item.nit;
      } else if (tipo == 2) {
        filename = 'facturas_recibidas' + this.item.nit;
      }
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
    exportarExcelAnual() {
      let info = [
        { CONCEPTO: "Total de Renta de actividades Lucrativas:", VALOR: this.item_aux.auxiliar_total_rentas },
        { CONCEPTO: "(-) Monto total de Rentas exentas:", VALOR: this.item_aux.auxiliar_rentas_exentas },
        { CONCEPTO: "Renta Imponible:", VALOR: this.item_aux.auxiliar_renta_imponible },
        { CONCEPTO: "Impuesto determinado:", VALOR: this.item_aux.impuesto_determinado },
        { CONCEPTO: "(-) Valor de las retenciones según declaraciones de este período a declarar:", VALOR: this.item_aux.retenciones },
        { CONCEPTO: "(=) Saldo del impuesto determinado:", VALOR: this.item_aux.retenciones },
        { CONCEPTO: "(-) ISO acreditado:", VALOR: this.item_aux.iso_acreditado },
        { CONCEPTO: "(-) Incentivos Fiscales: Decreto 29-89, 65-89 52-2003 y otros:", VALOR: this.item_aux.incentivos_fiscales },
        { CONCEPTO: "(-) Impuesto Pagado en este periodo:", VALOR: this.item_aux.impuesto_pagado },
        { CONCEPTO: "(=) Excedente de rentenciones en este periodo:", VALOR: this.item_aux.excedente_retencion },
        { CONCEPTO: "Impuesto no retenido o enterado durante este periodo:", VALOR: this.item_aux.impuesto_no_retenido },
        { CONCEPTO: "Total a Pagar:", VALOR: this.item_aux.auxiliar_remanente }
      ];
      let data = XLSX.utils.json_to_sheet(info);
      const workbook = XLSX.utils.book_new();
      const filename = 'cierre_anual_' + this.item.nit;
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    cargarTarjeta(card) {
      this.$emit('crearTarjeta', card);
      this.mostrarDialogTarjeta = false;
    },
    verDialogMensual(item) {
      console.log("verDialogMensual", item);
      console.log(item);
      this.item = item;
      this.dialogMensualAnual = true;
      this.data_fecha.fecha = '';
      this.data_fecha.fecha_usuario = '';
      this.facturas = [];
      this.totalFacturas = 0;
    },
    verDialogAnual(item) {
      console.log("verDialogAnual", item);
      this.item = item;
      this.select = '';
      this.anio_auxiliar = '';
      this.totales_facturas = 0;
      this.totales_impuesto = 0;
      this.totales_retenciones = 0;
      this.dialogAnual = true;
      this.declaraciones = [];
    },
    async getListadoDeclaracionesInicial() {
      console.log("getListadoDeclaracionesInicial");
      if (this.tipo) {
        this.data_fecha.fecha_usuario = this.date.split("-")
          .reverse()
          .join("/");
        let fecha = this.data_fecha.fecha_usuario.split("/");
        this.data_fecha.fecha = this.date;
        try {
          this.lodingData = true;
          let r =
            await this.$store.state.services.presentacionService.postlibrosVentas({ fecha: fecha[0] + "/" + fecha[1], usuario_id: this.item.id });
          console.log("libros de ventas");
          console.log(r);
          this.facturas = r.data.data.facturas;
          let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
          let total = r.data.data.total_facturas;
          this.totalFacturas = dollarUSLocale.format(total);
          this.lodingData = false;
          if (this.facturas == 0) {
            this.$toast.info("Sin movimiento")
            this.facturas = [];
          }
        } catch (error) {
          console.log(error);
          this.$toast.info(
            "No se encontraron coincidencias"
          );
          this.lodingData = false;
        }
      } else {
        this.data_fecha.fecha_usuario = this.date.split("-")
          .reverse()
          .join("/");
        let fecha = this.data_fecha.fecha_usuario.split("/");
        this.data_fecha.fecha = this.date;
        try {
          this.lodingData = true;
          let r =
            await this.$store.state.services.presentacionService.postlibrosCompras({ fecha: fecha[0] + "/" + fecha[1], usuario_id: this.item.id });
          console.log("libros de compras");
          console.log(r);
          this.facturas = r.data.data.facturas;
          let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
          let total = r.data.data.total_facturas;
          this.totalFacturas = dollarUSLocale.format(total);
          this.lodingData = false;
        } catch (error) {
          console.log(error);
          this.$toast.info(
            "No se encontraron coincidencias"
          );
          this.lodingData = false;
        }
      }
    },
    onChange() {
      console.log("onChange");
      console.log(this.select);
      this.$nextTick(() => {
        this.select = null
      })
    },
    async getReporteAnual() {
      console.log("getReporteAnual");
      this.isSelect = true;
      try {
        this.lodingData = true;
        this.anio_auxiliar = '';
        this.totales_facturas = 0;
        this.totales_impuesto = 0;
        this.totales_retenciones = 0;
        this.declaraciones = [];
        let r = await this.$store.state.services.administradorService.obtenerCierreAnualISR(this.select, this.item.id);
        console.log('obtenerCierreAnualISR', r);
        this.item_aux = r.data.data[0];
        console.log("item_aux:", this.item_aux);
        this.declaraciones = r;

        this.lodingData = false;
        this.anio_auxiliar = this.select;
        this.select = '';
      } catch (error) {
        console.log(error);
        this.$toast.info(
          "No se encontraron coincidencias"
        );
        this.lodingData = true;
      }
    }
  }
}